import { SizableText } from '@mythical/ui'
import Section from 'app/components/structure/Section'
import React from 'react'

import { ContentCardProps } from '../ContentCard'
import RelatedContentCarousel from './RelatedContentCarousel'

interface ContentCarouselProps {
  items: ContentCardProps[]
  title: string
  ctaHref?: string
  ctaLabel?: string
  noPadding?: boolean
  onNavigate?: () => void
  hideInfo?: boolean
  isVideo?: boolean
}

const normaliseDate = (date: string) => {
  if (!date) return new Date()
  const [day, month, year] = date.split('/')
  return new Date(`${year}-${month}-${day}`)
}

const RelatedContent = ({
  title,
  ctaHref,
  ctaLabel,
  items,
  noPadding = true,
  hideInfo,
  onNavigate,
  isVideo = false,
}: ContentCarouselProps) => {
  if (isVideo) {
    items?.sort((a, b) => {
      const datePublishedA: Date = normaliseDate(a?.datePublished)
      const datePublishedB: Date = normaliseDate(b?.datePublished)
      return datePublishedB?.valueOf() - datePublishedA?.valueOf()
    })
  }

  return (
    <Section
      title="More "
      titleHighlight={title}
      ctaHref={ctaHref}
      ctaLabel={ctaLabel}
      padded={!noPadding}
      bg="transparent"
    >
      {items?.length > 0 ? (
        <RelatedContentCarousel
          items={items}
          onNavigate={onNavigate}
          hideInfo={hideInfo}
        />
      ) : (
        <SizableText textTransform="uppercase" color="$secondary5">
          No content found
        </SizableText>
      )}
    </Section>
  )
}

export default RelatedContent
